module.exports = __webpack_public_path__ + "img/bh.834467b7.svg";